import React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/flame/Modal';

import { createReactRenderer } from 'root/apps/helpers/react-renderer';

import { StyledModal } from './ModalQuantity.style';

interface Props {
  cancelCallback: () => void;
  confirmCallback: () => void;
  unmount: () => void;
}

const ModalQuantity: React.FC<Props> = ({ cancelCallback, confirmCallback, unmount }) => {
  const [isOpen, setIsOpen] = React.useState(true);

  const handleDismiss = () => {
    cancelCallback();
    setIsOpen(false);
    unmount();
  };

  return (
    <StyledModal isOpen={isOpen} onRequestClose={handleDismiss} data-test="">
      <ModalHeader data-test="">You&apos;re about to update the quantity of your item</ModalHeader>
      <ModalBody style={{ paddingTop: '12px', paddingBottom: '12px' }}>
        Make sure the quantity is correct before proceeding.
      </ModalBody>

      <ModalFooter>
        <Flex justifyContent="end">
          <Button onClick={handleDismiss} data-test="quantity-cancel-button">
            Cancel
          </Button>
          <Button
            fill
            variant="secondary"
            ml={2}
            onClick={() => {
              setIsOpen(false);
              confirmCallback();
            }}
            data-test="quantity-confirm-button"
          >
            Update quantity
          </Button>
        </Flex>
      </ModalFooter>
    </StyledModal>
  );
};

export const setModalQuantity = (props: Omit<Props, 'unmount'>) => {
  const RenderedComponent = createReactRenderer({
    component: ModalQuantity,
    selector: '[data-react-root="ReactModal"]',
  });

  RenderedComponent.mount({ props: { ...props, unmount: RenderedComponent.unmount } });
};
